import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface WebsitePageDetail {
  url: string;
  page_type: string;
  total_engagements: number;
  people_engaged: number;
  sessions: number;
  first_engagement_date: string;
  last_engagement_date: string;
  channels: Array<{
    channel: string;
    engagements: number;
    people: number;
    sessions: number;
  }>;
}

export function useWebsitePagesByUrls(urls: string[]) {
  return useQuery({
    queryKey: ["website-pages", "by-urls", urls],
    queryFn: async () => {
      // urls is guaranteed to be non-empty due to enabled condition

      // For now, fetch each URL individually
      // In the future, we could implement a batch endpoint
      const promises = urls.map((url) => {
        const encodedUrl = encodeURIComponent(url);
        return api.get<WebsitePageDetail>(
          `datahub/webpages/detail/?url=${encodedUrl}`,
        );
      });

      return Promise.all(promises);
    },
    enabled: urls && urls.length > 0,
  });
}
